/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import { Map } from 'immutable';
import { denormalize } from 'normalizr';
import * as schemas from 'data/utils/schemas';
import {
  listLoadingProgress,
  airspaceOverviewLoadingProgress,
  audioSnippetsLoadingProgress,
} from 'data/reducers/airspaces';

import createImmutableEqualSelector from 'data/utils/immutable-selector';

const getState = (state) => state.airspaces;

export const getEntities = (state) => getState(state).get('entities');
export const getItem = (state, id) => {
  const entities = getEntities(state);
  return (
    entities.get(id) || entities.get(String(id)) || (Number.isFinite(Number(id)) ? entities.get(Number(id)) : undefined)
  );
};

export const getItemsList = createImmutableEqualSelector(getEntities, getState, (airspaces, state) =>
  denormalize(state.get('list'), [schemas.airspace], new Map({ airspaces })),
);

export const getItemsListLoaded = (state) => listLoadingProgress.getLoaded(getState(state));
export const getItemsListLoading = (state) => listLoadingProgress.getLoading(getState(state));
export const getItemsListLoadFailed = (state) => listLoadingProgress.getLoadFailed(getState(state));

export const getAirspaceOverview = (state) => getState(state).get('airspaceOverview');
export const getAirspaceOverviewLoaded = (state) => airspaceOverviewLoadingProgress.getLoaded(getState(state));
export const getAirspaceOverviewLoading = (state) => airspaceOverviewLoadingProgress.getLoading(getState(state));
export const getAirspaceOverviewLoadFailed = (state) => airspaceOverviewLoadingProgress.getLoadFailed(getState(state));

export const getAudioSnippets = (state) => getState(state).get('audioSnippets');
export const getAudioSnippetsLoaded = (state) => audioSnippetsLoadingProgress.getLoaded(getState(state));
export const getAudioSnippetsLoading = (state) => audioSnippetsLoadingProgress.getLoading(getState(state));
